// **********************************************************
//  Facilities-slider
// **********************************************************
/* eslint-disable */
$(function () {
  //  Facility slider
  new Swiper('.facilities-slider', {
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop: true,
    freeMode: true,
    autoplay: {
      delay: 3000,
    },
    pagination: {
      el: '.facilities-slider__pagination',
      clickable: true,
    },
    breakpoints: {
      600: {
        spaceBetween: 15,
      },
    },
  });
});
/* eslint-enable */
